import _globalThis2 from "../internals/global-this";
import _environmentIsNode from "../internals/environment-is-node";
var exports = {};
var _globalThis = _globalThis2;
var IS_NODE = _environmentIsNode;
exports = function (name) {
  if (IS_NODE) {
    try {
      return _globalThis.process.getBuiltinModule(name);
    } catch (error) {/* empty */}
    try {
      // eslint-disable-next-line no-new-func -- safe
      return Function("return require(\"" + name + "\")")();
    } catch (error) {/* empty */}
  }
};
export default exports;